const shouldPopupDisplayOnTop = () => {
  return false;
};

const SceneUtils = {
  shouldPopupDisplayOnTop,
};

export default SceneUtils;
